module.exports = __webpack_public_path__ + "media/images/item/rate_0_5-5709a89e1362c774ad8d43ca839a46b3.png";